import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { withAlert } from "./Alert";
import { downloadBlob } from "../blobUtils";

class FileDownloadButton extends Component {
  abortController = new global.AbortController();

  fetchFile = () => {
    if (!this.abortController.signal.aborted) {
      this.abortController.abort();
      this.abortController = new global.AbortController();
    }

    this.props
      .endpoint(this.props.data, this.abortController.signal)
      .then(response => {
        const data = this.props.fileExtension === "pdf" ? new Blob(["\ufeff", response]) : response;
        downloadBlob(this.props.fileExtension, data, this.props.filenamePrefix);
      })
      .catch(() => {
        this.props.showAlert("Błąd serwera", "danger");
      });
  };

  render() {
    const { name, disabled } = this.props;

    return (
      <button
        type="button"
        className={classNames("btn", this.props.className)}
        disabled={disabled}
        onClick={this.fetchFile}>
        {name}
      </button>
    );
  }
}

FileDownloadButton.propTypes = {
  endpoint: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  fileExtension: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disabled: PropTypes.bool,
  filenamePrefix: PropTypes.string,
};

export default withAlert(FileDownloadButton);
